export const localStorageSetItem =(key,value)=>{
    localStorage.setItem([key],value)
}

export const localStorageGetItem =({key})=>{
    return localStorage.getItem([key])
}